import React from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { Navigate } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth()

  console.log('🛡️ [ProtectedRoute] Status da autenticação:', {
    isAuthenticated,
    loading,
    timestamp: new Date().toISOString()
  })

  if (loading) {
    return (
      <div className="w-full h-dvh flex items-center justify-center bg-gray-400">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-neutral-600 border-t-neutral-50 rounded-full animate-spin"></div>
          <p className="text-neutral-50 text-lg">Verificando sessão salva...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    console.log('🚪 [ProtectedRoute] Usuário não autenticado, redirecionando para login')
    return <Navigate to="/login" replace />
  }

  console.log('✅ [ProtectedRoute] Usuário autenticado, permitindo acesso')
  return <>{children}</>
}